import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arguments",
  "use": "icon-arguments-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arguments\"><path d=\"M20.17,9.67H14.33V3.83a2.33,2.33,0,1,0-4.67,0V9.67H3.83a2.33,2.33,0,0,0,0,4.67H9.67v5.83a2.33,2.33,0,0,0,4.67,0V14.33h5.83a2.33,2.33,0,1,0,0-4.67Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol